import axios from 'axios';
import type { TaskDetail } from '../types/engineering';

const BASE = `${import.meta.env.APP_BASE_API_URL}/api/tasks`;

export const tasksApi = {
  getById: (id: string): Promise<TaskDetail> =>
    axios.get<TaskDetail>(`${BASE}/${id}`).then((r) => r.data),

  approve: (id: string, approved: boolean): Promise<TaskDetail> =>
    axios.patch<TaskDetail>(`${BASE}/${id}/approve`, { approved }).then((r) => r.data),

  updateDescription: (id: string, description: string): Promise<TaskDetail> =>
    axios.patch<TaskDetail>(`${BASE}/${id}/description`, { description }).then((r) => r.data),

  retryPlanner: (id: string): Promise<TaskDetail> =>
    axios.post<TaskDetail>(`${BASE}/${id}/retry-planner`).then((r) => r.data),

  retryImplementer: (id: string): Promise<TaskDetail> =>
    axios.post<TaskDetail>(`${BASE}/${id}/retry-implementer`).then((r) => r.data),

  retryVulnerabilityScan: (id: string): Promise<TaskDetail> =>
    axios.post<TaskDetail>(`${BASE}/${id}/retry-scan-vulnerabilities`).then((r) => r.data),
};
